import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ProductMenu } from '../src/components/header/ProductMenu';
import { getHeaderLocale } from '../src/WamazingUI/utils/i18n';
import { getLocaleFromSubdomain, getSubdomainFromNextLocale } from '../src/WamazingUI/utils/subdomain';

document.addEventListener('turbolinks:load', () => {
  const userLocale = ['p', 'staging'].includes(window.location.host.split('.')[0]) ? 'cn' : window.location.host.split('.')[0];
  const subdomain = getSubdomainFromNextLocale(userLocale);
  const locale = getLocaleFromSubdomain(subdomain);

  if (document.querySelector('#global-site-header__menu')) {
    ReactDOM.render(<ProductMenu lang={getHeaderLocale(locale)} productName={'snow'} />, document.querySelector('#global-site-header__menu'));
  }
});
